import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0D5CFF",
      "fill-rule": "evenodd",
      d: "M6.4 31.923 8 32h24l-.079-1.596c-.217-2.631-2.08-4.553-4.72-4.724l-1.6-.08H11.203L30.399 6.399l-.08-1.595C30.197 2.145 28.255.225 25.602.08L24 .007 0 0l.079 1.601c.21 2.606 2.1 4.568 4.718 4.72l1.602.078h14.398L1.601 25.602l.08 1.601c.157 2.638 2.06 4.548 4.718 4.718z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }